import { render } from "./professores-all.vue?vue&type=template&id=58b3bc36&scoped=true"
import script from "./professores-all.vue?vue&type=script&lang=js"
export * from "./professores-all.vue?vue&type=script&lang=js"

import "./professores-all.vue?vue&type=style&index=0&id=58b3bc36&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b3bc36"]])

export default __exports__